export default "__VITE_ASSET__CPJwEnD4__"